/**
 * @desc 新增
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.SystemConfigRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/systemConfig/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
